import * as React from 'react';
import { useEffect } from 'react';
import { betsActions } from '../../store/bets/actions';
import styles from './MyTips.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { Dispatch } from 'redux';
import { ownedBetsActions } from '../../store/ownedBets/actions';

import { EditTipConnected } from './EditTip';
import { betEditRequest } from '../../api/bets';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Masonry from 'react-masonry-component';
import { get } from 'lodash';
import SVG from 'react-inlinesvg';
import closeIcon from '../../assets/icons/close.svg';
import telegramIcon from '../../assets/icons/ic-telegram.svg';
import twitterIcon from '../../assets/icons/ic-twitter.svg';
import instagramIcon from '../../assets/icons/ic-instagram.svg';
import { postEvent } from '../../api/tracking';
import InfiniteScroll from '../../utils/InfiniteScroll';
import { LoginState } from '../../store/login/reducer';
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

import { BetsState } from '../../store/bets/reducer';

import { MyTipsTipBox } from './MyTipsTipBox';
import { UnlockedTipData } from '../../store/tips/reducer';
import { ClosedLiveBet } from './ClosedLiveBet';

export interface StateProps {
  openData: { tips: UnlockedTipData[]; matches: any };
  closedData: { tips: UnlockedTipData[]; matches: any };
  ownedMatches: any;
  loading: boolean;
  error: any;
  user: any;
  InitialSelectedBet?: any;
  openIsOpen?: boolean;
  closedIsOpen?: boolean;
  loginState: LoginState;
  betsState: BetsState;
}
export interface DispatchProps {
  getBets: (openstatus: any) => any;
  betEditRequest: (values: any) => any;
}
type MyTipsProps = StateProps & DispatchProps;

export const MyTips: React.FC<MyTipsProps> = ({
  InitialSelectedBet = null,
  getBets,
  openData,
  closedData,
  loading,
  loginState,
}) => {
  const { t } = useTranslation();
  const [selectedBet, setSelectedBet] = useState(InitialSelectedBet);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copyBtnAnimation, setCopyBtnAnimation] = useState(false);
  const [showOpen, setShowOpen] = useState(true);

  const [tipLink, setTipLink] = useState('');
  const oddsFormat =
    get(loginState, ['user', 'user', 'odds_format']) || 'DECIMAL';
  useEffect(() => {
    getBets('open');
    getBets('closed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const selectBet = (data: any) => {
    setSelectedBet(data);
  };
  const refreshBets = (correct: boolean) => {
    if (correct) {
      toast.success(tr(t, 'correct-tip_success'));
    } else {
      toast.error(tr(t, 'correct-tip_error'));
    }
    getBets('open');
    getBets('closed');
  };
  const OpenTips = openData.tips;
  const ClosedTips = closedData.tips;
  const loadTips = () => {
    if (!loading && ClosedTips.length > 0) {
      getBets(closedData.tips[ClosedTips.length - 1].id);
    }
  };

  useEffect(() => {
    const now = new Date();
    if (OpenTips[0]) {
      const newTip = new Date(OpenTips[0].created_at);
      newTip.setSeconds(newTip.getSeconds() + 3);

      if (
        now < newTip &&
        OpenTips[0].price_type !== 'FREE' &&
        OpenTips[0].price_type !== 'PREMIUM'
      ) {
        setIsModalOpen(true);
        setTipLink(`http://webapp.tipsterchat.com/tips/${OpenTips[0].id}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [OpenTips]);

  //tracking event
  const userId = get(loginState, ['user', 'user', 'id']);
  useEffect(() => {
    postEvent('MANAGE_TIPS_PAGE_VISITED', userId, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copiedAnimation = () => {
    setCopyBtnAnimation(true);
    setTimeout(() => {
      setCopyBtnAnimation(false);
    }, 2000);
  };

  return (
    <>
      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} style={{ maxWidth: '300px' }}>
            <a //eslint-disable-line
              onClick={() => setIsModalOpen(false)}
              className={styles.close}
            >
              <SVG src={closeIcon} />
            </a>

            <h1>{tr(t, 'tip_published')}</h1>
            <p className={styles.modalSubtitle}>{tr(t, 'share_this_link')}</p>
            <div className={styles.iconContainer}>
              <SVG src={telegramIcon} />
              <SVG src={twitterIcon} />
              <SVG src={instagramIcon} />
            </div>

            <input
              type="text"
              disabled
              value={tipLink}
              className={styles.clipBoard}
              onClick={(e: any) => {
                e.preventDefault();
                navigator.clipboard.writeText(tipLink);
                copiedAnimation();
              }}
            />
            <button
              className={
                copyBtnAnimation ? styles.copyBtnAnimation : styles.copyBtn
              }
              onClick={(e: any) => {
                e.preventDefault();
                navigator.clipboard.writeText(tipLink);
                copiedAnimation();
              }}
            >
              {copyBtnAnimation ? tr(t, 'copied') : tr(t, 'copy')}
            </button>
          </div>
        </div>
      )}
      {selectedBet ? (
        <EditTipConnected
          refreshBets={refreshBets}
          betEditRequest={betEditRequest}
          selectBet={selectBet}
          selectedBet={selectedBet}
          allMatches={openData.matches.filter((m: any) =>
            selectedBet.match_ids.includes(m.id),
          )}
        ></EditTipConnected>
      ) : (
        <div className={styles.container}>
          <div className={styles.section}>
            <label>{tr(t, 'tips')}</label>
            <h1>{tr(t, 'close')} </h1>
            <div className={styles.selectorWrapper}>
              <button
                onClick={() => setShowOpen(true)}
                id={showOpen ? styles.active : styles.inactive}
              >
                {tr(t, 'open_plural')}
              </button>
              <button
                onClick={() => setShowOpen(false)}
                id={showOpen ? styles.inactive : styles.active}
              >
                {tr(t, 'closed_plural')}
              </button>
            </div>
          </div>
          {showOpen ? (
            <div className={styles.masonryWrapper}>
              {/* @ts-ignore */}
              <Masonry>
                {openData.tips &&
                  OpenTips.map((tip) => (
                    <MyTipsTipBox
                      key={tip.id}
                      tip={tip}
                      oddsFormat={oddsFormat}
                      allMatches={openData.matches.filter((m: any) =>
                        tip.match_ids.includes(m.id),
                      )}
                      selectBet={selectBet}
                    />
                  ))}
              </Masonry>
            </div>
          ) : (
            <div className={styles.masonryWrapper}>
              <InfiniteScroll
                isLoading={loading}
                action={loadTips}
                isEmpty={!closedData.tips}
                styles={styles}
                disabled={ClosedTips.length <= 0}
              >
                {/* @ts-ignore */}
                <Masonry>
                  {closedData.tips &&
                    ClosedTips.map((tip) =>
                      tip.type === 'LIVE' ? (
                        <ClosedLiveBet
                          oddsFormat={oddsFormat}
                          key={tip.id}
                          data={tip}
                          EditTip
                          selectBet={selectBet}
                        />
                      ) : (
                        <MyTipsTipBox
                          key={tip.id}
                          tip={tip}
                          oddsFormat={oddsFormat}
                          allMatches={closedData.matches.filter((m: any) =>
                            tip.match_ids.includes(m.id),
                          )}
                        />
                      ),
                    )}
                </Masonry>
                {loading && <div>Loading...</div>}
              </InfiniteScroll>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: state.login.user,
  openData: state.ownedBets.data.open,
  closedData: state.ownedBets.data.closed,
  loading: state.ownedBets.isLoading,
  error: state.ownedBets.error,
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getBets: (openstatus: any) =>
    dispatch(ownedBetsActions.ownedBetsRequestAction(openstatus)),
  betEditRequest: (values: any) =>
    dispatch(betsActions.betEditRequestAction(values)),
});

export const MyTipsConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyTips);
